import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f8298e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Changelog", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { open: "" }, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.0 Initial Commit - "),
    /*#__PURE__*/_createElementVNode("time", null, "2021-09-04")
  ]),
  /*#__PURE__*/_createTextVNode(" This is the first release :D "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Did everything"),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, "Had some fun"),
    /*#__PURE__*/_createElementVNode("li", { class: "breaking" }, "Removed everything"),
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Created some bugs to fix later")
  ])
], -1))

import Modal from "components/Modal.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const isOpen = ref(false);

expose({
    open() {
        isOpen.value = true;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})